const CommunityScreen = () => {
  
    return (
       <p>Community Screen here</p>
    )
}

export default CommunityScreen